import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ITag } from '../../../models/tag';

@Component({
  selector: 'tag-select-menu',
  templateUrl: './select-menu.component.html',
  styleUrls: ['./select-menu.component.scss', '../tag-editor.component.scss']
})
export class SelectMenuComponent implements OnInit {
  @Input() items;
  @Input() disallowTags: string[] = [];
  @Output() onSelect = new EventEmitter<ITag>();
  @ViewChild('tagsListWrapper') tagsListWrapper: ElementRef;
  public menuIsDisplayed = false;
  public searchText = '';
  public unWantedTags: string[] = [
    'link',
    'accountid',
    'webevent.global.guest.bio.content',
    'webevent.global.presentation.content'
  ];

  @HostListener('document:click', ['$event'])
  onBlur(event: Event) {
    if (this.menuIsDisplayed) {
      this.menuIsDisplayed = this.tagsListWrapper.nativeElement.contains(event.target);
    }
  }
  constructor() {}

  ngOnInit() {}

  select(item: ITag) {
    this.onSelect.emit(item);
    this.menuIsDisplayed = false;
    this.searchText = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/tag-editor/select-menu/select-menu.component.ts